@import "../../../../styles/base";
@import "./surfaces";

.Button {
  border: none;
  color: $ds-violet-900;
  background-color: transparent;
  appearance: none;
  padding: 0.5em 1em;
  font-size: $ds-font-size-b1;
  line-height: 1.25em;
  border-radius: 0.25rem;
  font-weight: $ds-font-weight-medium;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  user-select: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  outline: none;

  &:focus-visible {
    outline-offset: 0.125rem;
    outline: $focus-outline;
  }

  @media screen and (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:not(:only-child, :last-child) {
    margin-right: 0.5em;
  }
}

.ButtonIcon {
  height: 1.25rem;
}

.small {
  min-height: 2rem;
  padding: 0 0.75em;
}

.medium {
  min-height: 2.5rem;
}

.large {
  min-height: 3rem;
  padding: 0 1.5em;
}

.fill {
  width: 100%;
  height: 100%;
  padding: 0;
  container: button / size;
  flex-wrap: wrap;
  align-content: center;

  @container button (height > 5rem) {
    .ButtonIcon {
      width: 100%;
      height: 3rem;
      position: relative;
      margin-bottom: 1rem;

      &::before {
        left: calc(50% - 1.5rem);
        position: absolute;
        z-index: 1;
        display: block;
        content: "";
        width: 3rem;
        height: 3rem;
        border-radius: 1.5rem;
        background-color: $ds-neutral-100;
      }

      > * {
        top: 0.75rem;
        left: calc(50% - 0.75rem);
        width: 1.5rem;
        height: 1.5rem;
        position: absolute;
        z-index: 2;
      }
    }
  }
}

// These styles are for iconbuttons, not the icon itself
.Icon {
  // BUTTON RULE: Icon buttons should always be somewhere the user expects to see a button and so, in general, don't need the full coloured-background styling. If they do for some reason, flag them as variant="highlight"
  @include button-group;

  height: 2rem;
  width: 2rem;
  padding: calc((2rem - 23px) / 2);
  display: flex;
  align-items: center;
  justify-content: center;

  &.xsmall {
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 3px;
    padding: 0.125rem;
  }

  &.medium {
    // The button is 2.5rems high, the icon is 20px, the border is 3px in total, so this centres it
    height: 2.5rem;
    width: 2.5rem;
    padding: calc((2.5rem - 23px) / 2);
  }
}
